// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-login[data-v-82b8e90e]{margin-top:80px;padding-bottom:20px}@media screen and (max-width:750px){.social-login[data-v-82b8e90e]{margin-top:0}}.login[data-v-82b8e90e]{background:#fff;z-index:1}.login-img img[data-v-82b8e90e]{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
